import type {
  ContactSupportViaServiceCloudKey,
  ContactSupportViaServiceCloudParams,
} from '../types';

export const getContactSupportViaServiceCloudKey = (
  ...params: ContactSupportViaServiceCloudParams
): ContactSupportViaServiceCloudKey => [
  'support',
  'contactSupportViaServiceCloud',
  ...params,
];
